import Router from "routes/routes";
import "./App.css";

function App() {
  return <>{Router()}</>;
}

export default App;
